<template>
  <div class="entrance">
    <el-card v-for="item in paperTable" :key="item.id">
      <div @click="link('exam', item.id)">
        <el-row type="flex" align="middle" :gutter="20">
          <el-col :span="8">
            <img width="100%" :src="item.cover" alt srcset />
          </el-col>
          <el-col :span="13">
            <h3>{{ item.title }}</h3>
            <p>创建时间：{{ item.created_at.split(" ")[0] }}</p>
          </el-col>
          <el-col :span="3" class="text-right">
            <span>></span>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "entrance",
  data() {
    return {
      paperTable: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.$http
        .get(process.env.VUE_APP_API_URL + "list")
        .then(function(data) {
          if (data.data.code == 200) {
            _this.paperTable = data.data.data;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    link(name, id) {
      console.log("in");
      this.$router.push({ name: name, params: { id: id } });
    },
  },
};
</script>
<style lang="less" scope>
a {
  text-decoration: none;
  color: #333;
}
.entrance {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  min-height: 100%;

  .el-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: none;
    border: none;
    .el-card__body {
      width: 100%;
    }
    h3 {
      margin: 0;
      font-size: 18px;
    }
    p {
      margin: 5px 0;
      color: #666;
      font-size: 12px;
    }
    span {
      color: #666;
    }
  }
}
</style>
